import { render, staticRenderFns } from "./feed-list.vue?vue&type=template&id=5125d294&scoped=true&"
import script from "./feed-list.vue?vue&type=script&lang=js&"
export * from "./feed-list.vue?vue&type=script&lang=js&"
import style0 from "./feed-list.vue?vue&type=style&index=0&id=5125d294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125d294",
  null
  
)

export default component.exports